import { NgModule } from "@angular/core";
import { DateDiffInDaysPipe } from "./date-diff-in-days.pipe";

@NgModule({
    imports: [],
    exports: [DateDiffInDaysPipe],
    declarations: [DateDiffInDaysPipe],
    providers: []
})
export class DateDiffInDaysPipeModule { }